import { call, put, select, takeEvery, takeLatest, take, delay } from 'redux-saga/effects';
import { push } from 'connected-react-router'
import * as api from "../../../firebase/api";
import { bannerTemplatesCollectionKey } from "../../../firebase/api";
import {
    IBannerTemplate,
} from "./types";
import { selectActiveBannerTemplate, selectBannerTemplateById, selectBannerTemplates } from "./selectors";
import {
    deleteBannerTemplateAsyncActions,
    fetchBannerTemplateByIdAsyncActions,
    fetchBannerTemplatesAsyncActions, linkBannerVariablesIdAsyncAction,
    modifyingActiveBannerTemplateAction, saveBannerTemplateAsyncActions,
} from "./actions";
import { setActiveBannerVariablesByIdAction } from "../variables/actions";
import { VariablesType } from "../variables/types";
import { IdObjectsWithId } from "../../../utils";
import { setActiveCampaignIdsAction, setActiveOrganizationIdAction } from "../../organizations/actions";
import {
    reLoadActiveFoldersAsyncAction
} from "./files/actions";
import { ICheckedFileIds, IFile, IFileWithData } from "../../files/types";
import { selectCheckedFileIds, selectFiles, selectFilesData, selectIsFilesLoading } from "../../files/selectors";
import { IFileData } from "../../files/filedata/types";
import { checkFilesAsyncAction, fetchAllFilesAsyncActions, ICheckFilesRequestActionPayload } from "../../files/actions";
import { IActiveFolders } from "./files/types";

function* putBannerTemplatesSaga(action: ReturnType<typeof fetchBannerTemplatesAsyncActions.success>) {
    yield put(action);
}
function* fetchBannerTemplatesSaga(action: ReturnType<typeof fetchBannerTemplatesAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.fetchCollection, bannerTemplatesCollectionKey);
        yield call(putBannerTemplatesSaga, fetchBannerTemplatesAsyncActions.success({ bannerTemplates: data }))
    } catch (e) {
        // @ts-ignore
        yield put(fetchBannerTemplatesAsyncActions.failure({ error: e }));
    }
}

function* fetchBannerTemplateByIdSaga(action: ReturnType<typeof fetchBannerTemplateByIdAsyncActions.request>) {
    try {
        let template: IBannerTemplate | undefined;
        let master: IBannerTemplate | undefined;

        let bannerTemplates: IdObjectsWithId<IBannerTemplate> = yield select(selectBannerTemplates);
        if (Object.keys(bannerTemplates.byId).length === 0) {
            yield call(fetchBannerTemplatesSaga, fetchBannerTemplatesAsyncActions.request({}))
            bannerTemplates = yield select(selectBannerTemplates);
            template = yield select(selectBannerTemplateById, action.payload.id);
            if (template && !template.isMaster && template.parentId) {
                master = yield select(selectBannerTemplateById, template.parentId);
            }
        } else {
            template = yield call(api.fetchDocById, bannerTemplatesCollectionKey, action.payload.id);
            if (template && !template.isMaster && template.parentId) {
                master = yield call(api.fetchDocById, bannerTemplatesCollectionKey, template.parentId);
            }
        }

        if (template) {
            yield put(fetchBannerTemplateByIdAsyncActions.success({
                bannerTemplate: template,
                masterBannerTemplate: master,
            }));
            yield put(setActiveBannerVariablesByIdAction({
                id: template.designBannerVariablesId,
                variablesType: VariablesType.DESIGN
            }));
            yield put(setActiveBannerVariablesByIdAction({
                id: template.feedBannerVariablesId,
                variablesType: VariablesType.FEED
            }))
            if (template.organizationId) {
                yield put(setActiveOrganizationIdAction({
                    organizationId: template.organizationId
                }))
                if (template.campaignIds && template.campaignIds.length > 0) {
                    yield put(setActiveCampaignIdsAction({
                        campaignIds: template.campaignIds
                    }))
                }
            }

            const folderIds = []
            if (template.htmlFolderId) {
                folderIds.push(template.htmlFolderId)
            }
            if (template.sassFolderId) {
                folderIds.push(template.sassFolderId)
            }
            if (folderIds.length > 0) {
                // @ts-ignore
                const isFilesLoading = yield select(selectIsFilesLoading)
                if (isFilesLoading) {
                    yield take(fetchAllFilesAsyncActions.success)
                }
                yield put(checkFilesAsyncAction.request({ folderIds: folderIds, disableUncheck: true }))
            }
        }
    } catch (e) {
        // @ts-ignore
        yield put(fetchBannerTemplateByIdAsyncActions.failure({ error: e }));
    }
}

function* saveBannerTemplatesSaga(action: ReturnType<typeof saveBannerTemplateAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.saveDocToCollection, bannerTemplatesCollectionKey, action.payload.bannerTemplate);
        yield put(saveBannerTemplateAsyncActions.success({ bannerTemplate: data }));
        yield put(push(`/templates/${data.id}`))

    } catch (e) {
        // @ts-ignore
        yield put(saveBannerTemplateAsyncActions.failure({ error: e }));
    }

}

function* deleteBannerTemplateByIdSaga(action: ReturnType<typeof deleteBannerTemplateAsyncActions.request>) {
    try {
        yield call(api.deleteDocById, bannerTemplatesCollectionKey, action.payload.id);
        yield put(deleteBannerTemplateAsyncActions.success({ id: action.payload.id }));
    } catch (e) {
        // @ts-ignore
        yield put(deleteBannerTemplateAsyncActions.failure({ error: e }));
    }
}

function* modifyBannerTemplatesSaga(action: ReturnType<typeof modifyingActiveBannerTemplateAction>) {
    yield put(modifyingActiveBannerTemplateAction(action.payload))
}

function* linkingBannerVariablesSaga(action: ReturnType<typeof linkBannerVariablesIdAsyncAction.request>) {
    try {
        let template: Partial<IBannerTemplate> = {};
        if (action.payload.variablesType === VariablesType.DESIGN) {
            template = { designBannerVariablesId: action.payload.bannerVariablesId }
        } else if (action.payload.variablesType === VariablesType.FEED) {
            template = { feedBannerVariablesId: action.payload.bannerVariablesId }
        }
        const modifyingAction: ReturnType<typeof modifyingActiveBannerTemplateAction> = modifyingActiveBannerTemplateAction({ bannerTemplate: template });
        yield call(modifyBannerTemplatesSaga, modifyingAction);
        // @ts-ignore
        const activeBannerTemplates = yield select(selectActiveBannerTemplate);
        yield put(saveBannerTemplateAsyncActions.request({ bannerTemplate: activeBannerTemplates }))
    } catch (e) {
        // @ts-ignore
        yield put(linkBannerVariablesIdAsyncAction.failure({ error: e }));
    }
}

function* reLoadActiveFoldersSaga(action: ReturnType<typeof reLoadActiveFoldersAsyncAction.request>) {
    const checkedFileIds: ICheckedFileIds = yield select(selectCheckedFileIds);
    const files: IdObjectsWithId<IFile> = yield select(selectFiles);
    const filesData: IdObjectsWithId<IFileData> = yield select(selectFilesData);

    const activeFolders = checkedFileIds.fileIds.reduce((result: IActiveFolders, id) => {
        const file = files.byId[id]
        const fileWithData: IFileWithData = {
            ...file,
        }
        if (file && file.parentId) {
            if (checkedFileIds.folderIds.includes(file.parentId)) {
                fileWithData.readonly = false;
            } else {
                fileWithData.readonly = true;
            }
        }
        if (file && file.fileDataId) {
            fileWithData.activeFileData = {
                ...filesData.byId[file.fileDataId]
            }
            if (file && /^\/.*\/html\//.test(file.path)) {
                result['html'][file.name] = fileWithData
            } else if (file && /^\/.*\/scss\//.test(file.path)) {
                result['scss'][file.name] = fileWithData
            }
        }
        return result

    }, {
        scss: {},
        html: {}
    })

    // yield delay(300)

    yield put(reLoadActiveFoldersAsyncAction.success({
        activeFolders: activeFolders
    }))

}

function* bannerTemplateActionWatcher() {
    yield takeLatest(fetchBannerTemplatesAsyncActions.request, fetchBannerTemplatesSaga);
    yield takeLatest(saveBannerTemplateAsyncActions.request, saveBannerTemplatesSaga);
    yield takeEvery(fetchBannerTemplateByIdAsyncActions.request, fetchBannerTemplateByIdSaga);
    yield takeEvery(deleteBannerTemplateAsyncActions.request, deleteBannerTemplateByIdSaga);
    yield takeLatest(linkBannerVariablesIdAsyncAction.request, linkingBannerVariablesSaga)
    yield takeLatest(reLoadActiveFoldersAsyncAction.request, reLoadActiveFoldersSaga)
}

export default bannerTemplateActionWatcher;

